module.exports = __webpack_public_path__ + "a17d279f/img/upload-icon.9179ae4e.svg";